import { render, staticRenderFns } from "./prefectures.vue?vue&type=template&id=2a2f607a&scoped=true&lang=pug&"
import script from "./prefectures.vue?vue&type=script&lang=js&"
export * from "./prefectures.vue?vue&type=script&lang=js&"
import style0 from "./prefectures.vue?vue&type=style&index=0&id=2a2f607a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f607a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2f607a')) {
      api.createRecord('2a2f607a', component.options)
    } else {
      api.reload('2a2f607a', component.options)
    }
    module.hot.accept("./prefectures.vue?vue&type=template&id=2a2f607a&scoped=true&lang=pug&", function () {
      api.rerender('2a2f607a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/myPage/prefectures.vue"
export default component.exports